import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { haptic } from '@/lib/telegram';

interface TabItem<T extends string> {
  id: T;
  label: ReactNode;
  icon?: ReactNode;
}

interface TabsProps<T extends string> {
  tabs: TabItem<T>[];
  active: T;
  onChange: (id: T) => void;
  className?: string;
}

export function Tabs<T extends string>({ tabs, active, onChange, className }: TabsProps<T>) {
  return (
    <div className={cn('flex gap-1 p-1 bg-bg-surface rounded-2xl border border-white/5', className)}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => {
            haptic('light');
            onChange(tab.id);
          }}
          className={cn(
            'flex-1 inline-flex items-center justify-center gap-2 px-3 py-2 rounded-xl text-sm font-medium transition',
            active === tab.id
              ? 'bg-accent text-white shadow-glow'
              : 'text-white/60 hover:text-white hover:bg-white/5',
          )}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );
}
